import { Loader2 } from 'lucide-react'
import { Button } from '@/modules/shared/components/ui/button'
import { Checkbox } from '@/modules/shared/components/ui/checkbox'
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/modules/shared/components/ui/form'

import { useAuthEmail } from '../hooks/use-auth-email.hook'
import { Input } from '@/modules/shared/components/ui/input'
import { AuthLayoutComponent } from '../components/auth-layout.component'

export function AuthEmailPage() {
	const {
		form,
		isLoading,
		error,
		submitAuthEmail,
		rememberEmail,
		setRememberEmail
	} = useAuthEmail()

	return (
		<AuthLayoutComponent
			titleAuth="Acessar conta"
			navigation="Ainda não tem acesso? Criar conta"
			route="/cadastro"
		>
			<Form {...form}>
				<form onSubmit={form.handleSubmit(submitAuthEmail)} className="space-y-6">
					<FormField
						control={form.control}
						name="email"
						render={({ field }) => (
							<FormItem>
								<FormLabel>Email</FormLabel>
								<FormControl>
									<Input
										type="email"
										placeholder="Digite seu email"
										{...field}
									/>
								</FormControl>
								<FormMessage />
							</FormItem>
						)}
					/>

					<div className="flex items-center space-x-2">
						<Checkbox
							id="remember-email"
							checked={rememberEmail}
							onCheckedChange={setRememberEmail}
							className="data-[state=checked]:bg-red-600 data-[state=checked]:border-red-600"
						/>
						<label
							htmlFor="remember-email"
							className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer text-gray-700 dark:text-gray-300"
						>
							Lembrar meu email
						</label>
					</div>

					{error && (
						<div className="text-sm text-red-600 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-3 text-center">
							Erro ao verificar email. Tente novamente.
						</div>
					)}

					<Button
						className="w-full"
						type="submit"
						disabled={isLoading}
					>
						{isLoading && <Loader2 size={16} className="mr-2 animate-spin" />}
						Próximo
					</Button>
				</form>
			</Form>
		</AuthLayoutComponent>
	)
}